import { render, staticRenderFns } from "./GuidesIndexView.vue?vue&type=template&id=4d33d044"
import script from "./GuidesIndexView.vue?vue&type=script&lang=js"
export * from "./GuidesIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports